import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";

import { tap, catchError } from "rxjs/operators";
import { Authorization } from "../model/authorization";
import { config } from "../config";
import { ErrorHandlerService } from "./errorHandler.service";

import { Router } from "@angular/router";
import { timeout } from "rxjs/operators";
import { Wait } from "../util/timeout";
import { DeliveryPackage } from "../model/deliveryPackage";

@Injectable({
  providedIn: "root",
})
export class DeliveryPackageService {
  lastGetFilteredParameters: any[] = [0, 0, ""];
  lastGetActivesParameters: any[] = [0, 0];
  lastGetWaitingOnLobbyParameters: any[] = [0, 0];

  constructor(
    private http: HttpClient,
    private handleError: ErrorHandlerService,
    private router: Router
  ) {}

  getAllPackages(): Observable<[]> {
    return this.http.get<any>(`${config.apiUrl}/DeliveryPackage`).pipe(
      timeout(Wait),
      tap((resp) => resp),
      catchError((error) => {
        console.log(error.error);
        if (error.message == "Timeout has occurred") {
          this.handleError.toastTimeout("Demora na comunicação com servidor");
        }
        return of([]);
      })
    );
  }

  getDeliveryPackage(id: number): Observable<DeliveryPackage | null> {
    return this.http.get<any>(`${config.apiUrl}/DeliveryPackage/${id}`).pipe(
      timeout(Wait),
      tap((resp) => resp),
      catchError((error) => {
        console.log(error.error);
        if (error.message == "Timeout has occurred") {
          this.handleError.toastTimeout("Demora na comunicação com servidor");
        }
        return of(null);
      })
    );
  }
  getDeliveryPackageQrCode(id: number): Observable<Blob | null> {
    return this.http.get(
      `${config.apiUrl}/DeliveryPackage/${id}/qrCodeImage`,
      { responseType: 'blob' }
    ).pipe(
      timeout(Wait),
      catchError((error) => {
        console.log(error.error);
        if (error.message == "Timeout has occurred") {
          this.handleError.toastTimeout("Demora na comunicação com servidor");
        }
        return of(null);
      })
    );
  }
  postStatusDeliveryPackage(id: string, dataQrCode: string, deliveredByQrcode: boolean): Observable<any> {
    let qrcode = JSON.stringify(dataQrCode)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      }),
    };
    return this.http.post<any>(`${config.apiUrl}/DeliveryPackage/${id}/${dataQrCode}/${deliveredByQrcode}/delivery`, httpOptions)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }));
  }

  getFilteredPackage(options, page: number): Observable<[]> {
    let params = new HttpParams()
    .set("page", options.page)
    .set("itemsPerPage", options.itemsPerPage)
    .set("delivered", options.delivered)
    .set("ownerUserId", options.ownerUserId)
    .set("registerUserId", options.registerUserId)
    .set("deliveredToUserId", options.deliveredToUserId)
    .set("startAt", options.startAt)
    .set("endAt", options.endAt)
    .set("name", options.textName)
    .set("unitOrCompany", options.unitOrCompany)

    return this.http.get<any>(`${config.apiUrl}/DeliveryPackage/filtered/${page}`, {params: params})
    .pipe(timeout(Wait),
    tap(resp => resp),
    catchError(error => {
      console.log(error.error);
      if (error.message == 'Timeout has occurred') {
        this.handleError.toastTimeout('Houve uma demora na comunicação com servidor');
      }
      return of([]);
    }));
  }

  addNew(deliveryPackage: DeliveryPackage): Observable<any> {
    return this.http.post<any>(`${config.apiUrl}/DeliveryPackage`, deliveryPackage)
      .pipe(
        timeout(Wait),
        tap((resp) => resp),
        catchError((error) => {
          console.log(error.error);
          this.handleError.popupError(
            error,
            "Falha na comunicação com o servidor..."
          );
          throw error.error;
        })
      );
  }

  updatePackage(deliveryPackageId: number, deliveryPackage: DeliveryPackage): Observable<any> {
    return this.http.put<any>(`${config.apiUrl}/DeliveryPackage/${deliveryPackageId}`, deliveryPackage)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possivel atualizar a autorização');
          return of(false);
        }));
  }

  deletePackage(id: number): Observable<any> {
    return this.http.delete<any>(`${config.apiUrl}/DeliveryPackage/${id}`).pipe(
      timeout(Wait),
      tap((resp) => resp),
      catchError((error) => {
        console.log(error.error);
        if (error.message == "Timeout has occurred") {
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possivel remover a autorização');
        }
        return of(false);
      })
    );
  }
}
